import {
  message,
  notification,
  PageHeader,
  Space,
  Spin,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, TableItem, dineroDisabledMask  } from "../../../../Components/Items";
import { contarVentasPPendientes } from "../../../../store/actions/empresa";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import ModalInsumosExtraVentasProgramadas from "./ModalInsumosExtraVentasProgramadas";

moment.locale("es");

class PendientesVentasProgramadas extends Component {
    state = {
        todasVentasProgramadas: [],
        loading: false,
        objetoProyectos: null,
        todasProyectos: [],
        ventasProgramadasSeleccionadas: [],
        modalConfirmacion: false,
        modalInsumosExtra: false,
        filtrosProyectos: [],
        cuentaLoading: 0,
        loadingNumber: false,
    };
    componentDidMount() {
        this.consultarDatosPendientes();
    }

    consultarDatosPendientes() {
        this.setState({ loading: true });
        axios
            .post(
                "ventasProgramadas/selectDatosPendientes",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    let filtrosProyectos = res.data.proyectos.map(valueProyecto => {
                        return {
                            text: valueProyecto.nombre,
                            value: valueProyecto._id.toString()
                        }
                    })
                    this.setState({
                        todasVentasProgramadas: res.data.ventasProgramadas.map((value) => {
                            let numero = value.ventaProgramadaSerie + ' ' + value.ventaProgramadaNumero
                            return {
                                ...value,
                                numero: numero,
                                moneda: value.moneda.abreviacion,
                                clienteObjeto: value.cliente,
                                clienteRfc: value.cliente.rfc,
                                clienteNombre: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)),

                            };
                        }),
                        filtrosProyectos
                    });
                } else {
                    message.error('Hubo un error y no se cargaron los datos')
                }
            });
    }

    atras() {
        this.props.history.goBack();
    }

    onSelectChange = (ventasProgramadasSeleccionadas) => {

        this.setState({ ventasProgramadasSeleccionadas });
        if (ventasProgramadasSeleccionadas.length === 1) {
            message.success(`Se ha seleccionado ${ventasProgramadasSeleccionadas.length} venta programada`)
        } else if (ventasProgramadasSeleccionadas.length > 1) {
            message.success(`Se han seleccionado ${ventasProgramadasSeleccionadas.length} ventas programadas`)
        }
    }

    abrirConfirmacion() {
        if (this.state.ventasProgramadasSeleccionadas.length > 0) {
            this.setState({ modalConfirmacion: true })
        } else {
            message.warning('Selecciona al menos una venta programada')
        }

    }

    cerrarDatosFacturaGlobal() {
        this.setState({ modalConfirmacion: false })
    }

    onFinishFailed(e) {
        e.errorFields.map((value, index) => {
            if (e.errorFields[index].name[1] || e.errorFields[index].name[1] === 0) {
                message.error(
                    "Error: " +
                    e.errorFields[index].errors[0] +
                    " en la fila " +
                    (e.errorFields[index].name[1] + 1)
                );
            } else {
                message.error("Error: Falta un campo");
            }
            return null;
        });
    }
    //`insumosExtraPorVenta`: { [ventaProgramadaId]: [{insumoId, cantidad, precioUnitario, descuento}] },
    //los insumos extra (p. ej. la luz) que se capturaron en ModalInsumosExtraVentasProgramadas.
    //Sin ellos el payload es el de siempre.
    async onFinish(insumosExtraPorVenta = {}) {
        //Candado síncrono: un doble clic generaría las ventas dos veces
        if (this.generando) return;
        this.generando = true;
        await this.setState({ loading: true, cuentaLoading: 0, loadingNumber: true });

        //Consultar en seria las ventas para evitar duplicados de folio

        let resultados = [];

        for (const ventaPId of this.state.ventasProgramadasSeleccionadas) {
            const insumosExtra = insumosExtraPorVenta[ventaPId];
            await axios
                .post(
                    "ventasProgramadas/generarVentaProgramada",
                    {
                        ventasProgramadaId: ventaPId,
                        empresaId: this.props.empresaId,
                        ...(insumosExtra?.length ? { insumosExtra } : {}),
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        resultados.push({ ventaPId, status: 'ok' });
                    } else if (res.data.success === 1) {
                        resultados.push({ ventaPId, status: 'error' });
                        const ventaP = this.state.todasVentasProgramadas.find((value) => value._id === ventaPId);
                        // Aquí NO va el overlay `MensajeError`: este botón procesa en serie
                        // todas las ventas seleccionadas, y el overlay se reemplaza a sí
                        // mismo, así que sólo se alcanzaría a ver el último rechazo. La
                        // notificación se apila. Por eso también lleva el número de la
                        // venta: sin él no se sabe cuál de las seleccionadas falló.
                        notification.error({
                            message: `Venta ${ventaP?.numero ?? ''}: `
                                + (res.data.errorTimbrado?.titulo || res.data.message || 'no se pudo registrar'),
                            description: [
                                res.data.errorTimbrado?.mensaje || res.data.description,
                                res.data.errorTimbrado?.detalleTecnico,
                            ].filter(Boolean).join('\n\n'),
                            duration: null,
                            style: { whiteSpace: 'pre-line' },
                        });
                    } else {
                        resultados.push({ ventaPId, status: 'error' });
                        const ventaP = this.state.todasVentasProgramadas.find((value) => value._id === ventaPId);
                        message.error(`Hubo un error y la venta ${ventaP.numero} no se registro`);
                    }
                    this.setState({ cuentaLoading: this.state.cuentaLoading + 1 });
                })
                .catch((err) => {
                    resultados.push({ ventaPId, status: 'error' });
                    this.setState({ cuentaLoading: this.state.cuentaLoading + 1 });
                })
        }

        this.generando = false;
        this.setState({ loadingNumber: false, ventasProgramadasSeleccionadas: [] });
        this.consultarDatosPendientes();
        const exitosas = resultados.filter(r => r.status === 'ok');
        message.success(`${exitosas.length} venta(s) fueron generadas correctamente.`);
        this.props.contarVentasPPendientes({ empresaId: this.props.empresaId }).then((response) => {
            if (response.success === 2) {
            } else {
                message.warning(response.err);
            }
        });
    }

    descargarExcel() {
        let datosDescargar = this.state.todasVentasProgramadas.map((value) => {
            return {
                Serie: value.ventaProgramadaSerie,
                Folio: value.ventaProgramadaNumero,
                Proyecto: value.proyecto.nombre,
                Cliente: value.clienteObjeto.persona ? value.clienteObjeto.razonSocial : (value.clienteObjeto.nombre + ' ' + value.clienteObjeto.apellidoPaterno + ' ' + value.clienteObjeto.apellidoMaterno),
                RFC: value.clienteObjeto.rfc,
                Moneda: value.moneda,
                "Fecha Ultima Venta": value.fechaUltimaVenta ? moment(value.fechaUltimaVenta).locale("es").format("DD/MM/YYYY") : "-",
                "Fecha Vencida": moment(value.fechaProximaVenta).locale("es").format("DD/MM/YYYY"),
                Subtotal: value.subtotal,
                Total: value.total,
                "Fecha Inicio": moment(value.fechaInicio).locale("es").format("DD/MM/YYYY"),
                "Fecha Fin": value.fechaFin ? moment(value.fechaFin).locale("es").format("DD/MM/YYYY") : "-",
                "Concurrencia": value.concurrencia ? value.concurrencia : "-",
                "Correo Automatico": value.correoAutomatico ? "Si" : "No",
                "Entregar Insumos": value.entregarInsumos ? "Si" : "No",
            }
        });
        const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas Programadas Pendientes");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, `Ventas_Programadas_Pendientes_${moment().locale("es").format("L")}.xlsx`);
    }

    render() {
        const columns = [
            {
                title: "VP",
                dataIndex: "numero",
                key: "numero",
                buscar: 'numero',
                width: "12%",
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                key: "proyecto",
                filters: this.state.filtrosProyectos,
                sorter: (a, b) => {
                    if (a.proyecto.nombre < b.proyecto.nombre) {
                        return -1;
                    }
                    if (a.proyecto.nombre > b.proyecto.nombre) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value.nombre,
                onFilter: (value, record) => record.proyectoId.toString().indexOf(value) === 0,
                width: "12%",
                ellipsis: true,
            },
           {
                title: "Cliente",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "cliente",
                render: (_, record) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>{record.clienteNombre}</span>
                </div>
                ),
                width: window.innerWidth >= 1800 ? "18%" : "20%",
                ellipsis: true,
            },
            {
                title: "RFC",
                dataIndex: "clienteRfc",
                key: "clienteRfc",
                render: (value) => (
                <div style={{ fontSize: "12px" }}>
                    {value}
                </div>
                ),
                width: "8%",
                ellipsis: true,

            },
          
            {
                title: "Fecha Última Venta",
                dataIndex: "fechaUltimaVenta",
                key: "fechaUltimaVenta",
                sorter: (a, b) => {
                    if (!a.fechaUltimaVenta) return 1;
                    if (!b.fechaUltimaVenta) return -1;
                    if (moment(a.fechaUltimaVenta) < moment(b.fechaUltimaVenta)) {
                        return -1;
                    }
                    if (moment(a.fechaUltimaVenta) > moment(b.fechaUltimaVenta)) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value ? moment(value).locale("es").format("ll") : "-",
                wdith: "16%",
                ellipsis: true,
                align: "center",
            },
            {
                title: "Fecha Vencida",
                dataIndex: "fechaProximaVenta",
                key: "fechaProximaVenta",
                sorter: (a, b) => {
                    if (moment(a.fechaProximaVenta) < moment(b.fechaProximaVenta)) {
                        return -1;
                    }
                    if (moment(a.fechaProximaVenta) > moment(b.fechaProximaVenta)) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => moment(value).locale("es").format("ll"),
                wdith: "16%",
                ellipsis: true,
                align: "center",
            },
             {
                title: "Subtotal / Total",
                dataIndex: "subtotal",
                key: "subtotal",
                responsive: ["md"],
                sorter: true,
                buscar: "subtotal",
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                            {dineroDisabledMask(record.subtotal)} {record.moneda}
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                            {dineroDisabledMask(record.total)} {record.moneda}
                        </div>
                    </div>
                ),
                width: "12%",
                align: "right",
            },
        ];
        return (
            <Spin spinning={this.state.loading} tip={this.state.loadingNumber ? ("Se han generado " + this.state.cuentaLoading + " ventas") : undefined} size="large">
                <PageHeader
                    title="Generar Ventas"
                    subTitle="Generar ventas a partir de las ventas programadas"
                    onBack={() => this.atras()}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={[
                        <ButtonItem
                            type="primary"
                            key="abrirConfirmacion"
                            onClick={this.abrirConfirmacion.bind(this)}
                            className="botonAgregar"
                        >
                            Generar Ventas
                        </ButtonItem>,
                        <ButtonItem
                            type="primary"
                            key="descargarExcel"
                            icon={<FileExcelOutlined />}
                            onClick={this.descargarExcel.bind(this)}
                            verde
                            className="botonAgregar"
                        >
                            Excel
                        </ButtonItem>
                    ]
                    }
                />
                <TableItem
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/editarVentaProgramada", { id: record._id });
                            },
                        };
                    }}
                    size="small"
                    dataSource={this.state.todasVentasProgramadas}
                    rowSelection={{
                        selectedRowKeys: this.state.ventasProgramadasSeleccionadas,
                        onChange: this.onSelectChange.bind(this),
                    }}
                    columns={columns}
                    pagination={false}
                />
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    spinning={false}
                >
                    <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
                    <p style={{ marginBottom: 4, textAlign: "center" }}>
                        {this.state.ventasProgramadasSeleccionadas.length > 1 ? `Se generaran ${this.state.ventasProgramadasSeleccionadas.length} ventas` : 'Se generara 1 venta'}
                    </p>
                    <p style={{ marginBottom: 14, textAlign: "center" }}>
                        ¿Quieres agregar más insumos (p. ej. la luz) o generarlas así?
                    </p>
                    <div style={{ textAlign: "center", marginBottom: 14 }}>
                        <Space>
                            <ButtonItem danger onClick={() => this.setState({ modalConfirmacion: false })}>
                                Cancelar
                            </ButtonItem>
                            <ButtonItem
                                blanco
                                onClick={() => this.setState({ modalConfirmacion: false, modalInsumosExtra: true })}
                            >
                                Agregar insumos
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                onClick={() => {
                                    this.setState({ modalConfirmacion: false });
                                    this.onFinish();
                                }}
                            >
                                Generar así
                            </ButtonItem>
                        </Space>
                    </div>
                </ModalItem>
                <ModalInsumosExtraVentasProgramadas
                    visible={this.state.modalInsumosExtra}
                    ventasProgramadas={this.state.todasVentasProgramadas.filter((value) =>
                        this.state.ventasProgramadasSeleccionadas.includes(value._id)
                    )}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    onCancel={() => this.setState({ modalInsumosExtra: false })}
                    onGenerar={(insumosExtraPorVenta) => {
                        this.setState({ modalInsumosExtra: false });
                        this.onFinish(insumosExtraPorVenta);
                    }}
                />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        certificada: state.empresa.certificada,
        envios: state.empresa.envios,
        permisoAgregarVenta:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
            )?.activado,
    };
};

export default connect(mapStateToProps, { contarVentasPPendientes })(PendientesVentasProgramadas);
